import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronLargeDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconChevronLargeDown"><Path fillRule="evenodd" clipRule="evenodd" d="M2.10546 9.36681C2.31716 9.01078 2.77739 8.89377 3.13342 9.10546L11.8723 14.3016C11.9511 14.3484 12.0491 14.3484 12.1279 14.3016L20.8668 9.10546C21.2228 8.89377 21.6831 9.01078 21.8948 9.36681C22.1065 9.72284 21.9895 10.1831 21.6334 10.3948L12.8945 15.5909C12.3433 15.9186 11.6569 15.9186 11.1057 15.5909L2.36681 10.3948C2.01078 10.1831 1.89377 9.72284 2.10546 9.36681Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronLargeDown;
